import { render, staticRenderFns } from "./ResearchInterest.vue?vue&type=template&id=9ca2a834&"
import script from "./ResearchInterest.vue?vue&type=script&lang=js&"
export * from "./ResearchInterest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports